import { FormControl, Grid, Typography } from '@mui/material';
import styles from '../reportSection.module.scss';
import { CommonButton, CustomCalendarTodayOutlinedIcon, CustomDatePicker, CustomMenuItem, CustomRequiredInputLabel, CustomSelectforFamily, StyledDateContainer, CustomInputLabel, CustomTextFeildforFamily, CommonOutlinedButton, formatAmount } from '../../common/StyledComponents/StyledFields';
import { useState, useEffect } from 'react';
import { ValidationError, object, string } from 'yup';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { apiRequest } from "../../../infrastructure/backendService";
import { donationTypesProps } from "../../../infrastructure/GlobalContextProvider";
import apiPath from "../../../config/apiPaths.json";
import { PoojaTypeListProps } from "../../../infrastructure/GlobalContextProvider";
import { ClipLoader } from 'react-spinners';
import ButtonLoader from '../../common/ButtonLoader/ButtonLoader';

interface ErrorMessageTypesSearch {
    amountUpperLimit: string
}
const formFieldsDonationReport = {
    searchByDonationDateFrom : dayjs().subtract(7, 'day').format("MM/DD/YYYY"),
    searchByDonationDateTo: dayjs().format("MM/DD/YYYY"),
    searchByMonthly: "",
    searchByQuarterly: "",
    selectYear: "",
    searchYear: "",
    searchCriteria: "",
    amount: "",
    amountUpperLimit: ""
}

/* donation report based on mode */
interface ErrorMessageTypesSearchMode {
    amountUpperLimitMode: string
}

const formFieldsDonationReportByMode = {
    searchByDonationDateFromMode:  dayjs().subtract(7, 'day').format("YYYY-MM-DD"),
    searchByDonationDateToMode: dayjs().format("YYYY-MM-DD"),
    searchCriteriaMode: "",
    donationModeId: "",
    donationTypeId: "",
    poojaId: "",
    signInName: "",
    amountMode: "",
    amountUpperLimitMode: ""
}
/* donation report based on mode */

const DonationReport = ({ sendDataToParent, getReportData }:any) => {
    const [errorMessageBookSummayry, setErrorMessageBookSummary] = useState<ErrorMessageTypesSearch>({ amountUpperLimit:"" });
    const [formDataBookDonationReport, setFormDataBookDonationReport] = useState(formFieldsDonationReport);

    const [errorMessageDonationReportMode, setErrorMessageDonationReportMode] = useState<ErrorMessageTypesSearchMode>({ amountUpperLimitMode:"" });
    const [formDataBookDonationReportMode, setFormDataBookDonationReportMode] = useState(formFieldsDonationReportByMode);

    const [isDateSearch, setIsDateSearch] = useState(false);
    const [isMonthSearch, setIsMonthSearch] = useState(false);
    const [isQuarterlySearch, setIsQuarterlySearch] = useState(false);

    const [donationModes, setDonationModes] = useState<donationTypesProps[]>([]);
    const [donationTypes, setDonationTypes] = useState<donationTypesProps[]>([]);
    const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>([]);
    const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>(0);
    const [selectedDonationModeId, setSelectedDonationModeId] = useState<number | undefined>(0);
    const [selectedDonationTypeId, setSelectedDonationTypeId] = useState<any | undefined>(0);

    const [loading, setLoading] = useState<boolean>(false);
    const [loading_donationPoojaBtn, setLoading_donationPoojaBtn] = useState<boolean>(false);
    const [DatePickerFromFirst, setDatePickerFromFirst] = useState(false);
    const [DatePickerToFirst, setDatePickerToFirst] = useState(false);
  
    useEffect(() => {
      setDatePickerFromFirst(false);
    }, [formDataBookDonationReportMode.searchByDonationDateFromMode]);
  
    useEffect(() => {
      setDatePickerToFirst(false);
    }, [formDataBookDonationReportMode.searchByDonationDateToMode]);
  
    const handleDatePickerFromClickFirst = () => {
      setDatePickerFromFirst(true);
    };
  
    const handleDatePickerToClickFirst = () => {
      setDatePickerToFirst(true);
    };

    const [DatePickerFromSecond, setDatePickerFromSecond] = useState(false);
    const [DatePickerToSecond, setDatePickerToSecond] = useState(false);
  
    useEffect(() => {
      setDatePickerFromSecond(false);
    }, [formDataBookDonationReport.searchByDonationDateFrom]);
  
    useEffect(() => {
      setDatePickerToSecond(false);
    }, [formDataBookDonationReport.searchByDonationDateTo]);
  
    const handleDatePickerFromClickSecond = () => {
      setDatePickerFromSecond(true);
    };
  
    const handleDatePickerToClickSecond = () => {
      setDatePickerToSecond(true);
    };

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const Quarterly = [
        "Jan-March",
        "April-June",
        "July-Sept",
        "Oct-Dec"
      ];

      const searchCriteria = [
        "<=",
        ">=",
        "=",
        "><"
      ];

      const validationSchema = object().shape({
        amountUpperLimit:formDataBookDonationReport.searchCriteria === "><" ? string().required("This field is Required") : string()
      });

      const validationSchemaforMode = object().shape({
        amountUpperLimitMode:formDataBookDonationReportMode.searchCriteriaMode === "><" ? string().required("This field is Required") : string()
      });
    
    const generateArrayOfYears = () => {
        let currentYear = new Date().getFullYear();
        var lastTenYears = currentYear - 10;
        var years = [];
      
        for (var i = currentYear; i >= lastTenYears; i--) {
          years.push(i);
        }
        return years;
      };

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.donationTypes,
          includeToken: true,
        })
          .then((res) => {
            setDonationModes(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.purposeOfDonations,
          includeToken: true,
        })
          .then((res) => {
            setDonationTypes(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

      useEffect(() => {
        apiRequest({
          method: "GET",
          endpoint: apiPath.poojaTypeByPoojaLocation,
          params: {
            poojaType: "TEMPLE_POOJA",
          },
          includeToken: true,
        })
          .then((res) => {
            setPoojaItemsList(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }, []);

    const handleSearchByDateChange = (field: any, value: any) => {
        if (field === "searchByDonationDateFrom" || field === "searchByDonationDateTo") {
            let formattedDate = dayjs(value, "MM/DD/YYYY");
            setFormDataBookDonationReport({
              ...formDataBookDonationReport,
              [field]: formattedDate.isValid()
                ? formattedDate.format("MM/DD/YYYY")
                : "",
            });
          } else {
            setFormDataBookDonationReport({
                ...formDataBookDonationReport,
                [field]: value,
            });
        }
        switch(field) {
          case "amount" :
            formDataBookDonationReport.amount = value;
            break;
          case "amountUpperLimit" :
            formDataBookDonationReport.amountUpperLimit = value;
            break;
          default :
           break; 
        }
    };

    const handleSearchByDateChangeDonationMode = (field: any, value: any) => {
        if (field === "searchByDonationDateFromMode" || field === "searchByDonationDateToMode") {
            let formattedDate = dayjs(value, "YYYY-YMM-DD");
            setFormDataBookDonationReportMode({
              ...formDataBookDonationReportMode,
              [field]: formattedDate.isValid()
                ? formattedDate.format("YYYY-MM-DD")
                : "",
            });
          }else if(field === 'signInName') {
            setFormDataBookDonationReportMode({
                ...formDataBookDonationReportMode,
                [field]: value.toUpperCase(),
            });
        }else{
          setFormDataBookDonationReportMode({
            ...formDataBookDonationReportMode,
            [field]: value,
        });
        }
        if(field === "donationModeId") {
            const selectedDonationMode = donationModes.find(
                (item: any) => item.name === value
              );
              setSelectedDonationModeId(selectedDonationMode?.id);
        }
        if(field === "donationTypeId") {
            const selectedDonationType = donationTypes.find(
                (item: any) => item.accountDescription === value
              );
              setSelectedDonationTypeId(selectedDonationType?.accountNumber);
        }
        if(field === "poojaId") {
            const selectedPooja = poojaItemsList.find(
                (item: PoojaTypeListProps) => item.name === value
              );
            setSelectedPoojaId(selectedPooja?.id);
        }

        switch(field) {
          case "amountMode" :
            formDataBookDonationReportMode.amountMode = value;
            break;
          case "amountUpperLimitMode" :
            formDataBookDonationReportMode.amountUpperLimitMode = value;
            break;
          default :
           break; 
        }
    };

    const getDonationPoojaReports = () => {
      const valueSelected:any = Object.entries(formDataBookDonationReportMode).reduce((a,[k,v]) => (v === "" ? a : ((a as any)[k]=v, a)), {});
      let reqBody:any = {};
      if(valueSelected["searchByDonationDateFromMode"] !== undefined && valueSelected["searchByDonationDateFromMode"] !== "" && valueSelected["searchByDonationDateToMode"] !== undefined && valueSelected["searchByDonationDateToMode"] !== "") {
          reqBody.searchStartDate = valueSelected["searchByDonationDateFromMode"];
          reqBody.searchEndDate = valueSelected["searchByDonationDateToMode"];
      }
      if(selectedDonationModeId !== 0) {
          reqBody.donationModeOfPaymentId = selectedDonationModeId;
      }
      if(selectedPoojaId !== 0) {
          reqBody.poojaTypeId = selectedPoojaId;
      }
      if(selectedDonationTypeId !== 0) {
          reqBody.donationsPurposeId = selectedDonationTypeId;
      }
      reqBody.signInName = valueSelected["signInName"];
      reqBody.searchAmount = valueSelected["amountMode"] || 0;
      reqBody.searchAmountUpperLimit = valueSelected["amountUpperLimitMode"];
      reqBody.searchCriteria = valueSelected["searchCriteriaMode"] || ">=";
      setLoading_donationPoojaBtn(true);
      apiRequest({
          method: "POST",
          endpoint: '/report-dashboard/reports/treasury/DONATION_PUJA_REPORT/browser',
          body: JSON.stringify(reqBody),
          includeToken:true
        })
        .then((res) => {
          setLoading_donationPoojaBtn(false);
          sendDataToParent(true,{reqBody:reqBody,reportName:'Donation Pooja Report',
            formData:formDataBookDonationReportMode
          });
          getReportData(res.data);
          setIsDateSearch(false);
          setIsMonthSearch(false);
          setIsQuarterlySearch(false);
        })
        .catch((err) => {
          setLoading_donationPoojaBtn(false);
        })
    };

    const getDonationReportsByMode = () => {
      const valueSelected:any = Object.entries(formDataBookDonationReport).reduce((a,[k,v]) => (v === "" ? a : ((a as any)[k]=v, a)), {});
      let reqBody:any = {};
      if(valueSelected["searchByDonationDateFrom"] !== undefined && valueSelected["searchByDonationDateFrom"] !== "" && valueSelected["searchByDonationDateTo"] !== undefined && valueSelected["searchByDonationDateTo"] !== "") {
          reqBody.searchStartDate = valueSelected["searchByDonationDateFrom"];
          reqBody.searchEndDate = valueSelected["searchByDonationDateTo"];
      } else if(valueSelected["searchByMonthly"] !== undefined && valueSelected["searchByMonthly"] !== "" && valueSelected["selectYear"] !== undefined && valueSelected["selectYear"] !== "") {
          let monthStartDate = dayjs(new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"])).format("MM/DD/YYYY");
          let monthEndDate = dayjs(new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"]+1, 0)).format("MM/DD/YYYY");
          reqBody.searchStartDate = monthStartDate;
          reqBody.searchEndDate = monthEndDate;
      } else if(valueSelected["searchByQuarterly"] !== undefined && valueSelected["searchByQuarterly"] !== ""  && valueSelected["searchYear"] !== undefined && valueSelected["searchYear"] !== "") {
          let quarterStartDate = dayjs(new Date(valueSelected["searchYear"], valueSelected["searchByQuarterly"])).format("MM/DD/YYYY");
          let quarterEndDate = dayjs(new Date(valueSelected["searchYear"], valueSelected["searchByQuarterly"]+3, 0)).format("MM/DD/YYYY");
          reqBody.searchStartDate = quarterStartDate;
          reqBody.searchEndDate = quarterEndDate;
      }
      reqBody.searchCriteria =  valueSelected["searchCriteria"] || ">=";
      reqBody.searchAmount = valueSelected["amount"] || 0;
      if(valueSelected["searchCriteria"] !== "" && valueSelected["searchCriteria"] === "><") {
          reqBody.searchAmountUpperLimit = valueSelected["amountUpperLimit"];
      }
      setLoading(true);
        apiRequest({
            method: "POST",
            endpoint: '/report-dashboard/reports/treasury/DONATION_REPORT/browser',
            body: JSON.stringify(reqBody),
            includeToken:true
          })
          .then((res) => {
            setLoading(false);
            sendDataToParent(true,{reqBody:reqBody,reportName:'Donation Report',
              formData:formDataBookDonationReport
            });
            // getReportData(res.data);  
            let counter = 1;
            const response = res.data.map((report:any)=>{
              return {
                "Sr.No.":counter++,
                "Sign-in Name":report.username,
                "Name":report.fullName,
                "Address":report.address,
                "Home Phone":report.phoneresidence,
                "Email":report.email,
                "Donation Amount":formatAmount(report.donationamount),
                "Refund Amount":formatAmount(report.refundamount),
            }
              })
            getReportData(response);
          })
          .catch((err) => {
            setLoading(false);
          })
    };

    const handlSubmitSummary = async () => {
        const errors: ErrorMessageTypesSearchMode = {
          amountUpperLimitMode:""
        }
        try {
          await validationSchemaforMode.validate(formDataBookDonationReportMode, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageDonationReportMode(errors);
            getDonationPoojaReports();
        } catch (error) {
            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesSearchMode] = e.message;
                    }
                });
            }
            setErrorMessageDonationReportMode(errors);
        }
    };

    const handlSubmitDonationMode = async () => {
        const errors: ErrorMessageTypesSearch = {
            ...formFieldsDonationReport
        }
        try {
           await validationSchema.validate(formDataBookDonationReport, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessageBookSummary(errors);
            getDonationReportsByMode();
        } catch (error) {
            if (error instanceof ValidationError) {
                error.inner.forEach((e) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypesSearch] = e.message;
                    }
                });
            }
            setErrorMessageBookSummary(errors);
        }
    };
    
    const FromDatePickerSearchFirst = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner} onClick={handleDatePickerFromClickFirst}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                             open={DatePickerFromFirst}
                             onClose={() => setDatePickerFromFirst(false)}
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataBookDonationReportMode.searchByDonationDateFromMode ? dayjs(formDataBookDonationReportMode.searchByDonationDateFromMode, 'YYYY-MM-DD') : ''
                                }
                                onChange={(value) => {
                                    handleSearchByDateChangeDonationMode('searchByDonationDateFromMode', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const ToDatePickerSearchFirst = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner} onClick={handleDatePickerToClickFirst}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                             open={DatePickerToFirst}
                             onClose={() => setDatePickerToFirst(false)}
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataBookDonationReportMode.searchByDonationDateToMode ? dayjs(formDataBookDonationReportMode.searchByDonationDateToMode, 'YYYY-MM-DD') : ''
                                }
                                onChange={(value) => {
                                    handleSearchByDateChangeDonationMode('searchByDonationDateToMode', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                                disabled={isDateSearch}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const DonationModeDropdownList = (): React.ReactElement => {
        return (
          <>
            <FormControl
              className={styles.moveToDropdown}
            >
              <CustomSelectforFamily
                IconComponent={KeyboardArrowDownIcon}
                defaultValue=""
                id="grouped-select"
                value={formDataBookDonationReportMode.donationModeId}
                onChange={(e) => {
                    handleSearchByDateChangeDonationMode("donationModeId", e.target.value);
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #F05802",
                      "& ul": {
                        paddingTop: 0,
                        paddingBottom: 0,
                        overflowY: "auto",
                        minHeight: "auto",
                        maxHeight: "300px",
                        "&::-webkit-scrollbar": {
                          width: "8px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#F3C539",
                          borderRadius: "6px",
                        },
                      },
                    },
                  },
                }}
              >
                {donationModes.map((item: any, i: any) => (
                  <CustomMenuItem value={item.name} key={i}>
                    {item.name}
                  </CustomMenuItem>
                ))}
              </CustomSelectforFamily>
            </FormControl>
          </>
        );
      };

      const DonationTypeDropdownList = (): React.ReactElement => {
        return (
          <>
            <FormControl
              className={styles.moveToDropdown}
            >
              <CustomSelectforFamily
                IconComponent={KeyboardArrowDownIcon}
                defaultValue=""
                id="grouped-select"
                value={formDataBookDonationReportMode.donationTypeId}
                onChange={(e) => {
                    handleSearchByDateChangeDonationMode("donationTypeId", e.target.value);
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #F05802",
                      "& ul": {
                        paddingTop: 0,
                        paddingBottom: 0,
                        overflowY: "auto",
                        minHeight: "auto",
                        maxHeight: "300px",
                        "&::-webkit-scrollbar": {
                          width: "8px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "#F3C539",
                          borderRadius: "6px",
                        },
                      },
                    },
                  },
                }}
              >
                {donationTypes.map((item: any, i: any) => (
                  <CustomMenuItem value={item.accountDescription} key={i}>
                    {item.accountDescription}
                  </CustomMenuItem>
                ))}
              </CustomSelectforFamily>
            </FormControl>
          </>
        );
      };

      const PoojaListDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formDataBookDonationReportMode.poojaId}
                        onChange={(e) => {
                            handleSearchByDateChangeDonationMode("poojaId", e.target.value);
                          }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {poojaItemsList.map((item: any, i: any) => (
                            <CustomMenuItem value={item.name} key={i}>
                                {item.name}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };

    const SelectCriteriaDropDownMode = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formDataBookDonationReportMode.searchCriteriaMode}
                        onChange={(e) => {
                            handleSearchByDateChangeDonationMode('searchCriteriaMode', e.target.value);
                            setErrorMessageDonationReportMode({...errorMessageDonationReportMode, amountUpperLimitMode:""})
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {searchCriteria.map((criteria: any, index: any) => (
                            <CustomMenuItem value={criteria} key={index}>
                                {criteria}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };

    const FromDatePickerSearchSecond = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner} onClick={handleDatePickerFromClickSecond}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                               open={DatePickerFromSecond}
                               onClose={() => setDatePickerFromSecond(false)}
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataBookDonationReport.searchByDonationDateFrom ? dayjs(formDataBookDonationReport.searchByDonationDateFrom, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleSearchByDateChange('searchByDonationDateFrom', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                                disabled={isDateSearch}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const ToDatePickerSearchSecond = (): React.ReactElement => {
        return (
            <div className={styles.dateconatiner}>
            <StyledDateContainer className={styles.styledConatiner} onClick={handleDatePickerToClickSecond}
            >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                             open={DatePickerToSecond}
                             onClose={() => setDatePickerToSecond(false)}
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formDataBookDonationReport.searchByDonationDateTo ? dayjs(formDataBookDonationReport.searchByDonationDateTo, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    handleSearchByDateChange('searchByDonationDateTo', value);
                                }}
                                disableFuture
                                className={styles.dateFeildforfamily}
                                disabled={isDateSearch}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </StyledDateContainer>
            </div>
        );
    };

    const SelectMonthDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        disabled={isMonthSearch}
                        value={formDataBookDonationReport.searchByMonthly}
                        onChange={(e) => {
                            handleSearchByDateChange('searchByMonthly', e.target.value);
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {months.map((month: any, index: any) => (
                            <CustomMenuItem value={index} key={index}>
                                {month}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };

    const SearchByQuarterlyDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        disabled={isQuarterlySearch}
                        value={formDataBookDonationReport.searchByQuarterly}
                        onChange={(e) => {
                            handleSearchByDateChange('searchByQuarterly', e.target.value);
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {Quarterly.map((quarter: any, index: any) => (
                            <CustomMenuItem value={index*3} key={index}>
                                {quarter}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };
    const SelectByYearDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        disabled={isMonthSearch}
                        value={formDataBookDonationReport.selectYear}
                        onChange={(e) => {
                            handleSearchByDateChange('selectYear', e.target.value);
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {generateArrayOfYears().map((year: any) => (
                            <CustomMenuItem value={year} key={year}>
                                {year}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };
    const SearchByYear = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        disabled={isQuarterlySearch}
                        value={formDataBookDonationReport.searchYear}
                        onChange={(e) => {
                            handleSearchByDateChange('searchYear', e.target.value);
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {generateArrayOfYears().map((year: any) => (
                            <CustomMenuItem value={year} key={year}>
                                {year}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };

    const SelectCriteriaDropDown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    className={styles.moveToDropdown}
                >
                    <CustomSelectforFamily
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formDataBookDonationReport.searchCriteria}
                        onChange={(e) => {
                            handleSearchByDateChange('searchCriteria', e.target.value);
                            setErrorMessageBookSummary({...errorMessageBookSummayry, amountUpperLimit:""})
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {searchCriteria.map((criteria: any, index: any) => (
                            <CustomMenuItem value={criteria} key={index}>
                                {criteria}
                            </CustomMenuItem>
                        ))}
                    </CustomSelectforFamily>
                </FormControl>
            </>
        );
    };

    const handleReset = () => {
      setFormDataBookDonationReportMode(formFieldsDonationReportByMode);   
    }

    const handleClear = () => {
      setFormDataBookDonationReport(formFieldsDonationReport);   
    }

    return (
      <>
        <div>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Date From", true)}
              {FromDatePickerSearchFirst()}
            </Grid>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Date To", true)}
              {ToDatePickerSearchFirst()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Mode", true)}
              {DonationModeDropdownList()}
            </Grid>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Type", true)}
              {DonationTypeDropdownList()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Pooja", false)}
              {PoojaListDropdown()}
            </Grid>
            <Grid item xs={12} sm={4}>
              <CustomInputLabel>Sign-In Name</CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                onChange={(e) => {
                  const inputValue = e.target.value;
                  handleSearchByDateChangeDonationMode(
                    "signInName",
                    inputValue
                  );
                }}
               className={styles.dateFeild}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search Criteria", true)}
              {SelectCriteriaDropDownMode()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              <CustomInputLabel>Amount</CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                value={formDataBookDonationReportMode.amountMode}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');                  
                  handleSearchByDateChangeDonationMode(
                    "amountMode",
                    inputValue
                  );
                }}
                className={styles.dateFeild }
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CustomInputLabel>
                If you have selected {"><"} search criteria, enter higher amount
                here
              </CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                value={formDataBookDonationReportMode.amountUpperLimitMode}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChangeDonationMode(
                    "amountUpperLimitMode",
                    inputValue
                  );
                  setErrorMessageDonationReportMode({...errorMessageDonationReportMode, amountUpperLimitMode:""})
                }}
                className={styles.dateFeild}
              />
                {errorMessageDonationReportMode.amountUpperLimitMode ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageDonationReportMode.amountUpperLimitMode}
              </Typography>
            ) : (
              ""
            )}
            </Grid>
          </Grid>
          <Grid sx={{ mt: 3, display: "flex", gap: "1rem" }}>
            <CommonButton
              sx={{ width: "fit-content", height: "38px" }}
              onClick={handlSubmitSummary}
              disabled={loading_donationPoojaBtn}
              id="submit"
            >
              <ButtonLoader isBtnLoading={loading_donationPoojaBtn} btnText={'Submit'} />
            </CommonButton>
            <CommonOutlinedButton onClick={handleReset}>Reset</CommonOutlinedButton>
          </Grid>
        </div>
        <div>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Date From", true)}
              {FromDatePickerSearchSecond()}
            </Grid>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Donation Date To", true)}
              {ToDatePickerSearchSecond()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Monthly", false)}
              {SelectMonthDropdown()}
            </Grid>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Select By Year", false)}
              {SelectByYearDropdown()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Quarterly", false)}
              {SearchByQuarterlyDropdown()}
            </Grid>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search By Year", false)}
              {SearchByYear()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              {CustomRequiredInputLabel("Search Criteria", false)}
              {SelectCriteriaDropDown()}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "0px" }}>
            <Grid item xs={12} sm={4}>
              <CustomInputLabel>Amount</CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                required
                value={formDataBookDonationReport.amount}
                onChange={(e) => {
                  const inputValue =e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChange("amount", inputValue);
                }}
                className={styles.dateFeild}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <CustomInputLabel>
                If you have selected {"><"} search criteria, enter higher amount
                here
              </CustomInputLabel>
              <CustomTextFeildforFamily
                style={{ minWidth: "100%", borderRadius: "8px" }}
                fullWidth
                value={formDataBookDonationReport.amountUpperLimit}
                onChange={(e) => {
                  const inputValue = e.target.value.replace(/[^0-9.]/g, '');
                  handleSearchByDateChange("amountUpperLimit", inputValue);
                  setErrorMessageBookSummary({...errorMessageBookSummayry, amountUpperLimit:""})
                }}
                className={styles.dateFeild}
              />
               {errorMessageBookSummayry.amountUpperLimit ? (
              <Typography sx={{ color: "red", fontSize: "12px" }}>
                {errorMessageBookSummayry.amountUpperLimit}
              </Typography>
            ) : (
              ""
            )}
            </Grid>
          </Grid>
          <Grid sx={{ mt: 3, display: "flex", gap: "1rem" }}>
            <CommonButton
              sx={{ width: "fit-content", height: "38px" }}
              onClick={handlSubmitDonationMode}
              disabled={loading}
              id="submit"
            >
              {loading ? (
                <>
                  <ClipLoader color="#fff" loading={loading} size={15} />
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                  >
                    Submitting...
                  </span>
                </>
              ) : (
                "Submit"
              )}
            </CommonButton>
            <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
          </Grid>
        </div>
      </>
    );
}
export default DonationReport;

//First Vunnavi DOnationMode ani Vadaru
// Second vunnavi normal ga fields vadaru